/**
 * @ngdoc object
 * @name guestlists.controller:GuestlistsCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .controller('CheckinCtrl', CheckinCtrl);

function CheckinCtrl() {
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/directives/checkin/checkin-directive-controller.js